module.exports = __webpack_public_path__ + "static/media/problem.93b2411c.png";